import { get, post } from '@/utils/apiBase.js';
// 获取更新列表
const getCpUpdateList = (option) => {
    return get('/apis/product/get_cp_update_list', option)
}
// 保存众筹更新
const saveProjectUpdate = option => {
    return post('/apis/product/save_project_update', option)
}
// 发布众筹更新
const releaseProjectUpdate = option => {
    return post('/apis/product/release_project_update', option)
}
// 获取众筹违规提示
const getUpdateViolationTips = option => {
    return get('/apis/product/get_update_violation_tips', option)
}
// 申请人工审核
const applyReAuditUpdate = option => {
    return post('/apis/product/apply_re_audit_update', option)
}
// 取消众筹更新发布
const cancelReleaseUpdate = option => {
    return post('/apis/product/cancel_release_update', option)
}
// 获取认证状态
const getUserAuthStatus = option => {
    //return get('/apis/product/get_user_auth_status', option)
    return get('/apis/userauth/query/info', option)
}
// 删除更新
const deleteProjectUpdate = option => {
    return post('/apis/product/delete_project_update', option)
}
// cp获取发布的更新详情
const getCpUpdateDetail = option => {
    return get('/apis/product/get_cp_update_detail', option)
}
// 预览
const updatePreview = option => {
    return post('/project_new/update_preview', option)
}
// 预览
const updateWdsPreview = option => {
    return post('/project_new_wds/update_preview', option)
}
// 获取项目信息
const getProjectInfo = option => {
    return get('/apis/product/get_project_info', option)
}
export default {
    getCpUpdateList,
    saveProjectUpdate,
    releaseProjectUpdate,
    getUpdateViolationTips,
    applyReAuditUpdate,
    cancelReleaseUpdate,
    getUserAuthStatus,
    deleteProjectUpdate,
    getCpUpdateDetail,
    updatePreview,
    updateWdsPreview,
    getProjectInfo
};